﻿import { NgProgress } from "ngx-progressbar";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { LoaderService } from "./loader.service";
import { LoaderState } from "./loader";

@Component({
    selector: "bo-loader",
    templateUrl: "loader.component.html"
})

export class LoaderComponent implements OnInit, OnDestroy {

    show = false;

    subscription: Subscription = new Subscription();

    constructor(
        private loaderService: LoaderService,
        private progressService: NgProgress
    ) { }

    ngOnInit(): void {
        this.subscription = this.loaderService.loaderState
            .subscribe((state: LoaderState) => {
                this.show = state.show;
                if (this.show) {
                    this.progressService.start();
                } else {
                    this.progressService.done();
                }
            });
    }

    showProgress(): void {
        this.progressService.start();
    }

    hideProgress(): void {
        this.progressService.done();
    }

    ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }
}
